module.exports = __webpack_public_path__ + "img/calendar.88b0972b.svg";